<template>
  <div class="form-group row">
    <div class="col-sm-12">
      <font size="1">
        <p size="1" v-if="errosValidacaoDesapensar.length" class="erro">
          <b size="1">Favor, verificar o(s) campo(s) abaixo:</b>
          <ul size="1">
            <li v-for="erro in errosValidacaoDesapensar" v-bind:key="erro" size="1">
              {{ erro }}
            </li>
          </ul>
        </p>
      </font>
    </div>
    <alert-comp :msg="msgAlert" />

    <div class="col-sm-2 text-sm-right">
      <label>Motivo da Desapensação:</label>
    </div>
    <div class="col-sm-10 mb-3">
      <textarea class="form-control" v-model="param.motivacao" rows="5"></textarea>
      <label class="erro">{{erroValidacaoDesapensarMotivo}}</label>
    </div>

    <div class="row btnAcoes">
      <button class="btn btn-outline-danger" @click.prevent="desapensar"> Desapensar </button>
    </div>
  </div>
</template>

<script>
import eventBus from '@/uteis/eventBus'
import alertComp from '@/components/alert/AlertComp'

import VirtusService from '@/services/VirtusService'

export default {
  name: 'desapensar',

  components: {
    alertComp
  },

  props: {
    eventBusRecarregar: { required: true, type: String },
    processoDesapensado: { required: true, type: Object }
  },

  data () {
    return {
      msgAlert: {
        texto: '',
        type: ''
      },
      param: {
        motivacao: ''
      },
      errosValidacaoDesapensar: [],
      erroValidacaoDesapensarMotivo: ''
    }
  },

  created () {
    this.service = new VirtusService()
  },

  methods: {
    desapensar () {
      if (this.validaDesapensacao()) {
        this.processoDesapensado.motivacao = this.param.motivacao

        this.service.desapensacoes(this.processoDesapensado).then((resp) => {
          eventBus.$emit(this.eventBusRecarregar, resp)
        })
      }
    },
    validaDesapensacao () {
      this.errosValidacaoDesapensar = []
      this.erroValidacaoDesapensarMotivo = ''

      if (!this.param.motivacao) {
        this.erroValidacaoDesapensarMotivo = '*Motivo desapensação obrigatório'
        this.errosValidacaoDesapensar.push('Campo Motivo Desapensação.')
      }

      if (!this.errosValidacaoDesapensar.length) {
        return true
      }
    }
  }
}
</script>

<style scoped lang="scss">
.row {
  margin-top: 2px;
}
.erro {
  color: orange;
}
</style>
